import { Box } from "orcs-design-system";
import React, { useState } from "react";

import CodeEditorField from "./CodeEditorField";
import { useDashboardData } from "./DashboardDataContext";
import QueriesEditor from "./QueriesEditor";

const DashboardEditPanel = () => {
  const { localCss, localTemplate, setLocalCss, setLocalTemplate, activeTab } =
    useDashboardData();

  return (
    <Box>
      <Box mt="s">
        {activeTab === "css" && (
          <CodeEditorField value={localCss} onChange={setLocalCss} lang="css" />
        )}
        {activeTab === "template" && (
          <CodeEditorField
            value={localTemplate}
            onChange={setLocalTemplate}
            lang="liquid"
          />
        )}
        {activeTab === "queries" && <QueriesEditor />}
      </Box>
    </Box>
  );
};

export default DashboardEditPanel;
